import React, { useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, QuoteIcon } from 'lucide-react';
interface Review {
  quote: string;
  author: string;
}
const reviews: Review[] = [{
  quote: "Quality experience, very pleased with product and installation. Angela's expertise and patience was appreciated. The installation crew was on top of their game and personable. We would recommend Granite and Marble Works to everyone.",
  author: 'Jack C. - Saratoga Springs, NY'
}, {
  quote: 'All went well..met all time frames for viewing stone, preparing template, all installation. Had all accessories available for purchase..well coordinated very cordial and accommodating staff. Larger inventory than others and vast showroom space. Well-run local business.',
  author: 'Virginia H. - Mechanicville, NY'
}, {
  quote: 'Granite and Marble Works Inc did a great job for us. They have a nice collection of stones to choose from. Their installers are well trained and very courteous. We are very happy to have chosen them.',
  author: 'J. P.- Ballston Lake, NY'
}, {
  quote: 'It is absolutely beautiful! I am so pleased with my marble top, the customer service and the installation. The installation crew were very neat, polite and had great expertise. It was installed to perfection! I will be back when I am ready to do my kitchen counter top!',
  author: 'Nancy M. - Johnstown, NY'
}];
export function TestimonialsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  function scrollByAmount(direction: 1 | -1) {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollBy({
      left: direction * (el.clientWidth * 0.8),
      behavior: 'smooth'
    });
  }
  return <section className="w-full bg-brand-charcoal" data-id="element-101" data-mp="277ljnb4c9suy">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-102" data-mp="2uyh8bzdi07xz">
        <div className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end" data-id="element-103" data-mp="2zpphcuax1ram">
          <h2 className="font-display text-3xl text-white sm:text-4xl" data-id="element-104" data-mp="39lftxdpoc84s">What Our Clients Say</h2>
          <div className="flex shrink-0 gap-2" data-id="element-105" data-mp="34mlbicvmcll7">
            <button type="button" onClick={() => scrollByAmount(-1)} aria-label="Scroll testimonials left" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:border-brand-teal hover:text-brand-teal" data-id="element-106" data-mp="34nwfodsz7vcu">
              <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-107" data-mp="2lw3mojdwqa54" />
            </button>
            <button type="button" onClick={() => scrollByAmount(1)} aria-label="Scroll testimonials right" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:border-brand-teal hover:text-brand-teal" data-id="element-108" data-mp="2luacwv7zz9sw">
              <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-109" data-mp="22yajrh3aa07q" />
            </button>
          </div>
        </div>

        <div ref={scrollRef} className="no-scrollbar mt-10 flex gap-5 overflow-x-auto scroll-smooth pb-2" data-id="element-110" data-mp="ieoxlqw636fz">
          {reviews.map(review => <div key={review.author} className="flex w-80 shrink-0 snap-start flex-col rounded-xl border border-white/10 bg-white/5 p-6 sm:w-96" data-id="element-111" data-mp="sd4n5pfjq7nd">
              <QuoteIcon className="h-6 w-6 text-brand-teal" aria-hidden="true" data-id="element-112" data-mp="3vumvdxz8dgob" />
              <p className="mt-4 flex-1 text-sm leading-relaxed text-white/80" data-id="element-113" data-mp="4nk65c2ydkgq">{review.quote}</p>
              <p className="mt-5 text-sm font-semibold text-white" data-id="element-114" data-mp="8pf2s39xv9o6">{review.author}</p>
            </div>)}
        </div>
      </div>
    </section>;
}